import React from 'react'
import { Box, Grid2, IconButton, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Text from '../genericComponents/Text';

const PageNavigator = ({
  pageLength,
  pageIndex,
  dataLength,
  totalCount,
  previousPage,
  nextPage,
  hasPreviousPage,
  hasNextPage,
  setPage
}) => {

  const theme = useTheme()

  return (
    <Grid2
      container
      style={{ border: `1px solid ${theme.palette.primary.main}` }}
      spacing={2}
      paddingLeft={2}
      alignItems="center"

    >
            
      <Box sx={{ flexGrow: 1 }} />
      <Grid2 xs={3} >
        <Text text={`i18n_items_totalpages ${Math.ceil(totalCount / pageLength)}`} variant="subtitle2" />
      </Grid2>
      <Grid2 xs={3}>
        <IconButton onClick={previousPage} disabled={!hasPreviousPage}>
          <ChevronLeft />
        </IconButton>
        <input style={{ width: '35px', textAlign: 'center', border: 0 }} value={pageIndex + 1} onChange={(e) => setPage(Math.min(Math.ceil(totalCount / pageLength) - 1, e.target.value - 1))}></input>
        <IconButton onClick={nextPage} disabled={!hasNextPage}>
          <ChevronRight />
        </IconButton>
      </Grid2>
    </Grid2>
  );
};

export default PageNavigator;
